<script setup>
import uiSidebar from '@/components/Sidebar/Sidebar.vue'
import { useRoute } from 'vue-router';

const route = useRoute()
</script>

<template>
  <div class="container" :style="route.path.indexOf('register/confirm') == 1 ? 'max-width: 1600px !important; width: 100% !important;' :' max-width: 100%  !important; width: 100% !important;'">
    <div :class="{'lk-container--nopadding': route.path == '/user/chats'}">
      <slot />
    </div>
  </div>
</template>

<style>

.lk-container--nopadding {
  gap: 0;
  grid-template-columns: 120px 1fr;
}
</style>
